module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.43589743589743,
						"dataLabels": {
							"enabled": true,
							"format": "38"
						}
					},
					{
						"y": 71.7948717948718,
						"dataLabels": {
							"enabled": true,
							"format": "28"
						}
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": true,
							"format": "27"
						}
					},
					{
						"y": 64.1025641025641,
						"dataLabels": {
							"enabled": true,
							"format": "25"
						}
					},
					{
						"y": 41.02564102564102,
						"dataLabels": {
							"enabled": true,
							"format": "16"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.4375,
						"dataLabels": {
							"enabled": true,
							"format": "63"
						}
					},
					{
						"y": 92.1875,
						"dataLabels": {
							"enabled": true,
							"format": "59"
						}
					},
					{
						"y": 92.1875,
						"dataLabels": {
							"enabled": true,
							"format": "59"
						}
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": true,
							"format": "56"
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "32"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.08219178082192,
						"dataLabels": {
							"enabled": true,
							"format": "358"
						}
					},
					{
						"y": 91.78082191780823,
						"dataLabels": {
							"enabled": true,
							"format": "335"
						}
					},
					{
						"y": 90.95890410958904,
						"dataLabels": {
							"enabled": true,
							"format": "332"
						}
					},
					{
						"y": 83.28767123287672,
						"dataLabels": {
							"enabled": true,
							"format": "304"
						}
					},
					{
						"y": 54.52054794520548,
						"dataLabels": {
							"enabled": true,
							"format": "199"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.3157894736842,
						"dataLabels": {
							"enabled": true,
							"format": "183"
						}
					},
					{
						"y": 87.89473684210526,
						"dataLabels": {
							"enabled": true,
							"format": "167"
						}
					},
					{
						"y": 86.8421052631579,
						"dataLabels": {
							"enabled": true,
							"format": "165"
						}
					},
					{
						"y": 76.31578947368422,
						"dataLabels": {
							"enabled": true,
							"format": "145"
						}
					},
					{
						"y": 55.78947368421052,
						"dataLabels": {
							"enabled": true,
							"format": "106"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.564102564102566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.315789473684216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.349206349206349,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.0847457627118615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9178082191780854,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.424581005586594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.8955223880596996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.433734939759042,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.539473684210535,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.68421052631579,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.743169398907103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.19760479041916,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.121212121212121,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.89655172413793,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=39"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=64"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=365"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=190"
			}
		],
		"dataTable": {
			"East Kootenay": [
				39,
				38,
				28,
				27,
				25,
				16
			],
			"Kootenay Boundary": [
				64,
				63,
				59,
				59,
				56,
				32
			],
			"Okanagan": [
				365,
				358,
				335,
				332,
				304,
				199
			],
			"Thompson Cariboo Shuswap": [
				190,
				183,
				167,
				165,
				145,
				106
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_7.json
// module id = 240
// module chunks = 0